import React, { useState } from 'react';
import BemClass from '@upsales/components/Utils/bemClass';
import Comment from 'App/resources/Model/Comment';
import { Card, ButtonSelect, Flex } from '@upsales/components';
import NoteRow from './NoteRow';
import { AIGeneratedContentCard } from 'Components/AIGeneratedContentCard/AIGeneratedContentCard';
import MeetingDebriefView from 'Components/Modals/Appointment/MeetingDebriefView';
import { useTranslation } from 'Components/Helpers/translate';
import './TimelineNoteComments.scss';
import { useSoftDeployAccess } from 'App/components/hooks';

const renderCommentRow = (comment: Comment, key: number) => {
	return <NoteRow comment={comment} key={key} />;
};
const renderNoteSection = (notes: string, classes: BemClass) => {
	if (!notes) {
		return null;
	}
	return (
		<div className={classes.elem('notes-section').b()}>
			<NoteRow text={notes} iconProps={{ icon: 'pencil', color: 'grey-10' }} hideEdit />
		</div>
	);
};

interface Props {
	comments: Comment[];
	notes?: string;
	aiNotes?: string;
	aiNotesEn?: string;
	internalDebrief?: any;
	internalDebriefEn?: any;
}

const TimelineNoteComments = ({ comments, notes, aiNotes, aiNotesEn, internalDebrief, internalDebriefEn }: Props) => {
	const classes = new BemClass('TimelineNoteComments');
	const { t } = useTranslation();
	const [selectedLanguage, setSelectedLanguage] = useState('original');
	const hasInternalMeetingDebriefFeature = useSoftDeployAccess('INTERNAL_MEETING_DEBRIEF');

	const hasInternalDebrief = hasInternalMeetingDebriefFeature && (internalDebrief || internalDebriefEn);
	const hasEnglishDebriefVersion =
		internalDebriefEn && JSON.stringify(internalDebrief) !== JSON.stringify(internalDebriefEn);
	const debriefToShow = selectedLanguage === 'english' && internalDebriefEn ? internalDebriefEn : internalDebrief;

	const hasEnglishVersion = aiNotesEn && aiNotesEn !== aiNotes;
	const aiNotesToShow = selectedLanguage === 'english' ? aiNotesEn : aiNotes;

	const showLanguageToggle =
		(hasInternalDebrief && hasEnglishDebriefVersion) || (!hasInternalDebrief && hasEnglishVersion);

	const hasNotesOrComments =
		!!notes?.length || !!comments.length || !!aiNotes?.length || !!aiNotesEn?.length || hasInternalDebrief;

	if (!hasNotesOrComments) {
		return null;
	}

	return (
		<Card className={classes.b()}>
			{comments.map(c => renderCommentRow(c, c.id))}
			{notes && !hasInternalDebrief ? renderNoteSection(notes, classes) : null}

			{(hasInternalDebrief || aiNotesToShow) && (
				<div className={classes.elem('AIGeneratedContentCard').b()}>
					{showLanguageToggle ? (
						<Flex
							alignItems="center"
							justifyContent="flex-end"
							className={classes.elem('languageToggle').b()}
						>
							<ButtonSelect
								size="sm"
								value={selectedLanguage}
								onChange={setSelectedLanguage}
								options={[
									{
										value: 'original',
										title: t('default.original')
									},
									{
										value: 'english',
										title: 'English'
									}
								]}
							/>
						</Flex>
					) : null}
					<AIGeneratedContentCard title="default.summary" isLoading={false}>
						{hasInternalDebrief ? (
							<MeetingDebriefView
								debrief={debriefToShow}
								forceEnglish={selectedLanguage === 'english'}
								hideTitle={true}
							/>
						) : (
							<p>{aiNotesToShow}</p>
						)}
					</AIGeneratedContentCard>
				</div>
			)}
		</Card>
	);
};
export default TimelineNoteComments;
